'use client';
import dynamic from 'next/dynamic';

import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import TechnologyFaq from '@/components/technologies/technology-faq';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import AndroidFAQ from '@/components/faqs/android-faq';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import AndroidServies from '@/components/technologies/android-demand';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Build highly scalable and robust native Android apps using the latest tools and Android SDK. By using our Android app development services, you can deliver seamless experiences across all Android devices and platforms to maximize your business efficiency."
                alt="hero image"
                title="hero image"
                width={582}
                height={550}
                path={'android-developer-hero'}
                bgPath={'hero-bg-grunge'}
            >
                Android App <div>Development Company</div>
            </TechHeroApp>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Android" />
            <ContetVideoSection title="Develop Custom Android App For Digitally Driven Business Operations">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Android is a widely used mobile app development operating system. To develop real-time Android apps
                        various powerful frameworks (MVC, MVP, MVVM, Native script), Databases (SQLite, Realm, Room) Android
                        Firebase SDK, and libraries (RxJava, Retrofit, Dagger2, etc) are leveraged. There are several types of
                        programming languages used in Android app development such as Kotlin, JAVA, Python, С#, C++, and more.
                        However, Kotlin is a quite preferred cross-platform programming language for Android app development these
                        days.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        Moweb is a highly reputed Android App Development Company specializing in building custom Android apps for
                        smartphones, tablets, wearables, or Android TVs. Our native Android app development services cater to
                        different industry verticals and lines of businesses for a sustainable and seamless mobile experience.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        Hire our Android team comprising business consultants, QA experts, and DevOps programmers who can rapidly
                        understand your project requirements and deliver impeccable digital products. Whether you hire dedicated
                        Android developers or a team you can control the performance of development, review their code quality,
                        and make sure that deliverables fulfill your expectations.
                    </p>
                </>
            </ContetVideoSection>
            <AndroidServies />
            <HireProcess
                bg="bg-androidapp"
                pageTitle="Hire Android App Developers To Augment Your Outreach"
                desc="Get a free consultation to build a top-tier Android solution. Our Android programmers continuously stay updated on all the databases, frameworks, platforms, tools, and languages."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For Android Application Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best Android Developers"
                desc="Select from different engagement models to hire Android Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <TechnologyFaq title="FAQs On Android Development Services" bg="bg-androidapp">
                <AndroidFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
